export default __webpack_public_path__ + "static/media/cart-01-PT.06546803.jpg";